import { useCounterparties } from '@/features/counterparties/api/useCounterparties'
import { MergeSheet } from '@/features/directories/components/MergeSheet'
import type { CounterpartyRow } from '@/types/domain'

/* Folding one counterparty into another (S-22b) — the client merge's sheet
 * (`MergeSheet`, shared on purpose: the two merges are one act from the
 * reader's side), fed with the right candidates.
 *
 * The candidates are the SAME CATEGORY only, asked of the server by that
 * category: it refuses a merge across categories (422 `category: mismatched`),
 * and offering the others would only meet that refusal. Active ones only — the
 * kept record is where every reference lands, and folding into a record the
 * desk has stopped working with would retire the references with it. Read only
 * while the sheet is open. */
export function CounterpartyMergeSheet({
  open,
  onClose,
  source,
  pending,
  error,
  onConfirm,
}: {
  open: boolean
  onClose: () => void
  /** The record being folded away. */
  source: Pick<CounterpartyRow, 'id' | 'name' | 'category'>
  pending?: boolean
  /** The refusal, already worded — `counterpartyMergeErrorMessage`. */
  error?: string
  onConfirm: (targetId: string) => void
}) {
  const { data: candidates } = useCounterparties(
    { categories: [source.category] },
    { enabled: open },
  )

  return (
    <MergeSheet
      open={open}
      onClose={onClose}
      source={open ? source : undefined}
      candidates={(candidates ?? []).filter((row) => row.category === source.category)}
      pending={pending}
      error={error}
      onConfirm={onConfirm}
    />
  )
}
